import { useState } from 'react';
import ModalShell from './ModalShell';
import { useTranslation } from '../../hooks/useTranslation';
import { ALL_PAGES } from '../Layout';

const PagesModal = ({ user, onClose, onSave }) => {
  const { t } = useTranslation();
  const [selectedPages, setSelectedPages] = useState(user.visible_pages || []);

  const toggle = (path) =>
    setSelectedPages((prev) =>
      prev.includes(path) ? prev.filter((p) => p !== path) : [...prev, path]
    );

  return (
    <ModalShell
      title={t('users.editPagesTitle', { username: user.username })}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
          <button type="button" className="btn btn-primary" onClick={() => onSave(selectedPages)}>{t('common.save')}</button>
        </>
      }
    >
      <div className="modal-body">
        <p>{t('users.selectPagesPrompt')}</p>
        <div className="d-flex flex-column gap-2">
          {ALL_PAGES.map((page) => (
            <div className="form-check" key={page.path}>
              <input
                className="form-check-input"
                type="checkbox"
                id={`page-${page.path}`}
                checked={selectedPages.includes(page.path)}
                onChange={() => toggle(page.path)}
              />
              <label className="form-check-label" htmlFor={`page-${page.path}`}>
                <i className={`bi ${page.icon} me-1`}></i>
                {page.labelKey ? t(page.labelKey) : page.label}
                <small className="text-muted ms-2">{page.path}</small>
              </label>
            </div>
          ))}
        </div>
      </div>
    </ModalShell>
  );
};

export default PagesModal;
